<template>
  <div class="pg">
    <nodata-for-detail title="暂未评估" v-if="noData">
      <p class="mt5 flex aic jcc" v-if="isAID_ADM">
        <el-button size="mini" type="primary" @click="$emit('add')">立即填写</el-button>
      </p>
    </nodata-for-detail>
    <template v-else>
      <div id="print">
        <h2 class="flex jcc pt20 pb20">直升机转运患者评估系统</h2>
        <table style="width: 100%">
          <tr v-for="(f,i) in yjpgxtForm">
            <td width="10%" v-if="i===0" rowspan="8">一般模块</td>
            <td width="10%" v-if="i===0" :rowspan="yjpgxtForm.length">预检系统评估</td>
            <td width="10%" v-html="f.label"></td>
            <td width="70%">
              <template v-if="f.type==='inputGroup'">
                <pg-table-input class="pr10" v-for="(ff,ii) in f.value" :key="ii" :pre="ff.pre" :suf="ff.suf"
                                :value="ff.data"></pg-table-input>
              </template>
              <pg-table-radio v-if="f.type==='radioGroup'" :data="f.value" :value="f.data"></pg-table-radio>
            </td>
          </tr>
          <tr v-for="(f,i) in qdhxxtForm">
            <td width="10%" v-if="i===0" :rowspan="qdhxxtForm.length">气道呼吸系统</td>
            <td width="10%" v-html="f.label"></td>
            <td width="70%">
              <template v-if="f.type==='inputGroup'">
                <pg-table-input class="pr10" v-for="(ff,ii) in f.value" :key="ii" :pre="ff.pre" :suf="ff.suf"
                                :value="ff.data"></pg-table-input>
              </template>
              <pg-table-radio v-if="f.type==='radioGroup'" :data="f.value" :value="f.data"></pg-table-radio>
            </td>
          </tr>
          <tr v-for="(f,i) in jxxjgsForm">
            <td width="10%" v-if="i===0" rowspan="28">特殊模块</td>
            <td width="10%" v-if="i===0" :rowspan="jxxjgsForm.length">急性心肌梗死</td>
            <td width="10%" v-html="f.label"></td>
            <td width="70%">
              <template v-if="f.type==='inputGroup'">
                <pg-table-input class="pr10" v-for="(ff,ii) in f.value" :key="ii" :pre="ff.pre" :suf="ff.suf"
                                :value="ff.data"></pg-table-input>
              </template>
              <template v-if="f.type==='diy'">
                <p v-for="(d,ii) in f.value">
                  <pg-table-checkbox v-if="d.type==='checkboxGroup'" :data="d.value"
                                     :value="d.data"></pg-table-checkbox>
                  <pg-table-radio v-if="d.type==='radioGroup'" :data="d.value" :value="d.data"></pg-table-radio>
                </p>
              </template>
              <pg-table-checkbox v-if="f.type==='checkboxGroup'" :data="f.value" :value="f.data"></pg-table-checkbox>
              <pg-table-checkbox-pic v-if="f.type==='checkboxGroupPic'" :data="f.value"
                                     :value="f.data"></pg-table-checkbox-pic>
            </td>
          </tr>
          <tr v-for="(f,i) in xeForm">
            <td width="10%" v-if="i===0" :rowspan="xeForm.length">小儿</td>
            <td width="10%" v-html="f.label"></td>
            <td width="70%">
              <template v-if="f.type==='inputGroup'">
                <pg-table-input class="pr10" v-for="(ff,ii) in f.value" :key="ii" :pre="ff.pre" :suf="ff.suf"
                                :value="ff.data"></pg-table-input>
              </template>
              <pg-table-radio v-if="f.type==='radioGroup'" :data="f.value" :value="f.data"></pg-table-radio>
            </td>
          </tr>
          <tr v-for="(f,i) in ssForm">
            <td width="10%" v-if="i===0" :rowspan="ssForm.length">烧伤</td>
            <td width="10%" v-html="f.label"></td>
            <td width="70%">
              <template v-if="f.type==='inputGroup'">
                <pg-table-input class="pr10" v-for="(ff,ii) in f.value" :key="ii" :pre="ff.pre" :suf="ff.suf"
                                :value="ff.data" :input-class="ff.inputClass"></pg-table-input>
              </template>
              <pg-table-radio v-if="f.type==='radioGroup'" :data="f.value" :value="f.data"></pg-table-radio>
            </td>
          </tr>
          <tr v-for="(f,i) in csForm">
            <td width="10%" v-if="i===0" :rowspan="csForm.length">创伤</td>
            <td width="10%" v-html="f.label"></td>
            <td width="70%">
              <template v-if="f.type==='diy'">
                <p v-for="(dd,ii) in f.value" :key="ii">
                  <pg-table-checkbox v-if="dd.type==='checkboxGroup'" :data="dd.value"
                                     :value="dd.data"></pg-table-checkbox>
                  <template v-if="dd.type==='inputGroup'">
                    <pg-table-input class="pr10" v-for="(fff,iii) in dd.value" :key="iii" :pre="fff.pre" :suf="fff.suf"
                                    :value="fff.data" :input-class="fff.inputClass"></pg-table-input>
                  </template>
                </p>
              </template>
              <template v-if="f.type==='radioGroupArray'">
                <p v-for="(dd,ii) in f.value" :key="ii" class="flex wrap aic">
                  <span>{{ dd.label }}（</span>
                  <pg-table-checkbox v-if="dd.type==='checkboxGroup'" :data="dd.value"
                                     :value="dd.data"></pg-table-checkbox>
                  <pg-table-radio v-else :data="dd.value" :value="dd.data"></pg-table-radio>
                  <span>）</span>
                </p>
              </template>
              <pg-table-checkbox v-if="f.type==='checkboxGroup'" :data="f.value"
                                 :value="f.data"></pg-table-checkbox>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <h2>NIHSS评分风险评估（7~22分）：共<input class="w60 fs24" readonly :value="info.nihssScoringRiskAssessment"
                                             style="text-align:center;border: none 0px; border-bottom: 1px solid #333; padding: 0px 5px; outline: none;"/>分
              </h2>
            </td>
          </tr>
          <tr v-for="(f,i) in zzForm">
            <td width="10%" v-if="i===0" :rowspan="zzForm.length">卒中</td>
            <td width="10%" v-html="f.label"></td>
            <td width="70%">
              <template v-if="f.type==='inputGroup'">
                <pg-table-input class="pr10" v-for="(ff,ii) in f.value" :key="ii" :pre="ff.pre" :suf="ff.suf"
                                :value="ff.data"></pg-table-input>
              </template>
              <pg-table-radio v-if="f.type==='radioGroup'" :data="f.value" :value="f.data"></pg-table-radio>
            </td>
          </tr>
        </table>
      </div>
      <div class="flex mt15 jcc" v-if="isAID_ADM">
        <el-button size="mini" type="primary" @click="print()">打印</el-button>
        <el-button size="mini" type="success" @click="$emit('edit',info.id)">修改</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import NodataForDetail from "@/modules/staff/components/nodata-for-detail";
import {staffService} from "@/modules/staff/service/staff";
import {isEmpty} from '@/common/lib/utils'
import PgTableInput from "@/modules/form/components/pg-table-input";
import {
  PG_TABLE_FIELDS,
  yjpgxtForm,
  qdhxxtForm,
  jxxjgsForm,
  xeForm,
  ssForm,
  csForm,
  zzForm
} from "@/modules/staff/config";
import {STAFF_ADD_PG, STAFF_EDIT_PG} from "@/modules/staff/events";
import PgTableRadio from "@/modules/form/components/pg-table-radio";
import {handlerTrauma} from "@/modules/staff/filter";
import PgTableCheckbox from "@/modules/form/components/pg-table-checkbox";
import PgTableCheckboxPic from "@/modules/form/components/pg-table-checkbox-pic";
import Print from '@mathewparet/vue-print'


export default {
  name: "pg-table",
  components: {PgTableCheckboxPic, PgTableCheckbox, PgTableRadio, PgTableInput, NodataForDetail, Print},
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      info: {},
      fields: {},
      yjpgxtForm, qdhxxtForm, jxxjgsForm, xeForm, ssForm, csForm, zzForm
    }
  },
  computed: {
    noData() {
      return isEmpty(this.info);
    },
  },
  created() {
    this.getDetail();
    bus.$on(STAFF_EDIT_PG.id, this.getDetail)
    bus.$on(STAFF_ADD_PG.id, this.getDetail)
  },
  beforeDestroy() {
    bus.$off(STAFF_EDIT_PG.id, this.getDetail)
    bus.$off(STAFF_ADD_PG.id, this.getDetail)
  },
  methods: {
    print() {
      window.Print(document.getElementById('print'));
    },
    async getDetail() {
      this.info = await staffService.pgDetail(this.id);
      this.fields = this.getFields();
    },
    getFields() {
      let obj = {};
      const {yjpgxtForm, info, qdhxxtForm, jxxjgsForm, xeForm, ssForm, csForm, zzForm} = this;

      const handler = r => {
        if (r.type === 'inputGroup') {
          r.value.forEach(rr => {
            if (info[rr.id]) this.$set(rr, 'data', info[rr.id])
          });
        }
        if (r.type === 'radioGroup') {
          this.$set(r, 'data', info[r.id]);
          //扩展选项处理
          r.value.forEach(rr => {
            if (rr.id) {
              info[rr.id] && this.$set(rr, 'data', info[rr.id]);
            }
          })
        }

        if (r.type === 'checkboxGroup') {
          let data = info[r.id];
          if (data) {
            data = data.split('-');
            this.$set(r, 'data', data);
          }
          //扩展选项处理
          r.value.forEach(rrr => {
            if (rrr.id) {
              info[rrr.id] && this.$set(rrr, 'data', info[rrr.id]);
            }
          })
        }

        if (r.type === 'checkboxGroupPic') {
          let data = info[r.id];
          if (data) {
            data = data.split('-');
            this.$set(r, 'data', data);
          }
          //扩展选项处理
          r.value.forEach(rrr => {
            let id = rrr.id + 'Url';
            if (id) {
              info[id] && this.$set(rrr, 'data', info[id]);
            }
          })
        }

        if (r.type === 'radioGroupArray') {
          r.value.forEach(rr => {
            if (rr.type === 'checkboxGroup') {
              let data = info[rr.id];
              if (data) {
                data = data.split('-');
                this.$set(rr, 'data', data);
              }
              //扩展选项处理
              rr.value.forEach(rrr => {
                if (rrr.id) {
                  info[rrr.id] && this.$set(rrr, 'data', info[rrr.id]);
                }
              })
            } else {
              this.$set(rr, 'data', info[rr.id]);
              //扩展选项处理
              rr.value.forEach(rrr => {
                if (rrr.id) {
                  info[rrr.id] && this.$set(rrr, 'data', info[rrr.id]);
                }
              })
            }
          })
        }

        if (r.type === 'diy') {
          r.value.forEach(rr => {
            if (rr.type === 'checkboxGroup') {
              let data = info[rr.id];
              if (data) {
                data = data.split('-');
                this.$set(rr, 'data', data);
              }
              //扩展选项处理
              rr.value.forEach(rrr => {
                if (rrr.id) {
                  info[rrr.id] && this.$set(rrr, 'data', info[rrr.id]);
                }
              })
            }
            if (rr.type === 'radioGroup') {
              this.$set(rr, 'data', info[rr.id]);
              //扩展选项处理
              rr.value.forEach(rrr => {
                if (rrr.id) {
                  info[rrr.id] && this.$set(rrr, 'data', info[rrr.id]);
                }
              })
            }
            if (rr.type === 'inputGroup') {
              rr.value.forEach(rrr => {
                if (info[rrr.id]) this.$set(rrr, 'data', info[rrr.id])
              });
            }
          })
        }
        if (r.id === 'trauma') {
          this.$set(r, 'data', handlerTrauma(info.trauma, 'detail'));
        }
      }

      yjpgxtForm.forEach(handler);
      qdhxxtForm.forEach(handler);
      jxxjgsForm.forEach(handler);
      xeForm.forEach(handler);
      ssForm.forEach(handler);
      csForm.forEach(handler);
      zzForm.forEach(handler);
      /*for (let key in PG_TABLE_FIELDS) {
        obj[key] = PG_TABLE_FIELDS[key].map(r => {
          let field;
          if (typeof r.field === 'object') {//填空
            field = r.field.map(rr => {
              let value
              if (typeof rr.field === 'object') {
                value = rr.field.map(rrr => info[rrr]).join(rr.gutter || '/')
              } else value = info[rr.field];
              return {...rr, value}
            })
          } else if (r.type === 'mul') {//单选集合
            r.data.map(rr => {
              rr.label = info[rr.id];
            })
          } else {//单选
            field = r.field;
            r.value = info[field];
            if (field === 'trauma') {
              r.value = handlerTrauma(r.value, 'detail');
            }
            //包含 extra
            if (r.extra && r.extra.length) {
              r.extra.map(rr => {
                rr.value = info[rr.field];
              })
            }
          }
          return {
            ...r,
            field
          }
        });
      }*/
      return obj;
    }
  },
}
</script>

<style scoped lang="scss">
table {
  border-collapse: collapse;
  table-layout: fixed;

  td {
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid #333333;
  }
}
</style>
